import { ModalBackground, ele } from "cables-shared-client";

import api from "./api.js";
import web from "./index.js";
import Patchlists from "./patchlists.js";

export default class PatchListModalDialog
{
    constructor()
    {
        this._patchlists = new Patchlists();
    }

    togglePatchListDialog(id, type = "project")
    {
        const bg = new ModalBackground({ "listenToEsc": true });
        bg.show();
        bg.on("hide", () =>
        {
            ele.hide(dialogTab);
        });

        let dialogTab = ele.byId("patchlist-dialog");

        if (!dialogTab)
        {
            dialogTab = document.createElement("div");
            dialogTab.id = "patchlist-dialog";
            ele.hide(dialogTab);
            document.body.appendChild(dialogTab);
        }
        dialogTab.innerHTML = "<div id=\"patchlist-suggest\" class=\"modalcontainer\"><div class=\"modalinner\"><span class=\"loading\"></span></div></div>";

        if (dialogTab.classList.contains("hidden"))
        {
            ele.show(dialogTab);
            let url = "suggest/patchlists?p=" + id;
            let title = "Add patch to patchlists";
            if (type === "op")
            {
                title = "<i class=\"icon icon-lock\"></i> Add op to patchlists";
                url = "suggest/patchlists?op=" + id;
            }
            api.get(url,
                (res) =>
                {
                    const hasNonPublicLists = res.data.find((list) => { return list.visibility !== "public"; });
                    const hasNonDefaultLists = res.data.find((list) => { return list.type !== "default"; });

                    res.data.sort((a, b) => { return a.name.localeCompare(b.name); });

                    web.setHandleBarHtml("patchlist_suggest", {
                        "title": title,
                        "id": id,
                        "type": type,
                        "url": url,
                        "lists": res.data,
                        "hasNonDefaultLists": hasNonDefaultLists,
                        "hasNonPublicLists": hasNonPublicLists
                    }, dialogTab);
                    ele.byId("patchlistsearch").focus();
                },
                () => {});

            const autoSuggests = dialogTab.querySelectorAll("[data-autosuggest]");
            web.initializeAutosuggestsFromApi(autoSuggests, { "focusElement": dialogTab.querySelector("input") });
        }
        else
        {
            ele.hide(dialogTab);
            bg.hide();
        }
    }

    handleModalSelection(listId, id, type, listName, listLink)
    {
        const listItem = ele.byId("listRow" + listId);
        const checkBox = ele.byId("listCheckbox" + listId);
        const eleLoading = ele.byId("patchListDialogLoading");
        const onList = listItem.dataset.onList === "true";
        const listsContainer = ele.byId("patch-lists");

        ele.show(eleLoading);

        if (onList)
        {
            this._patchlists.removeItem(listId, id, type, false, () =>
            {
                listItem.dataset.onList = "false";
                if (checkBox) checkBox.checked = false;
                if (listsContainer)
                {
                    const list = listsContainer.querySelector("li[data-list-id='" + listId + "']");
                    if (list)
                    {
                        list.remove();
                        const lists = listsContainer.querySelectorAll(".lists li");
                        let numLists = 0;
                        if (lists && lists.length) numLists = lists.length;
                        if (!numLists)
                        {
                            ele.hide(listsContainer);
                        }
                        else
                        {
                            const s = listsContainer.querySelector(".plural");
                            if (s)
                            {
                                if (numLists > 1) ele.show(s);
                                else ele.hide(s);
                            }
                        }
                    }
                }
                ele.hide(eleLoading);
            });
        }
        else
        {
            this._patchlists.addItem(listId, id, type, () =>
            {
                listItem.dataset.onList = "true";
                if (checkBox) checkBox.checked = true;
                if (listsContainer)
                {
                    const lists = listsContainer.querySelector(".lists");
                    const hasList = lists.innerHTML.length > 0;
                    let html = "<li data-list-id=\"" + listId + "\"><a class=\"list\" href=\"" + listLink + "\">" + listName + "</a></li>";
                    lists.innerHTML += html;
                    if (hasList)
                    {
                        const s = listsContainer.querySelector(".plural");
                        if (s) ele.show(s);
                    }
                    ele.show(listsContainer);
                }
                ele.hide(eleLoading);
            });
        }
    }

    handleModalSearch(searchEle)
    {
        let search = searchEle.value;
        if (search) search = search.toLowerCase();
        const modal = ele.byId("patchlist-suggest");
        if (search && modal)
        {
            const listItems = Array.from(modal.querySelectorAll(".modalcontent tr"));
            listItems.forEach((listItem) =>
            {
                let content = listItem.innerText;
                if (content) content = content.toLowerCase();
                if (content && content.includes(search))
                {
                    ele.show(listItem);
                }
                else
                {
                    ele.hide(listItem);
                }
            });
        }
        else if (modal)
        {
            const listItems = Array.from(modal.querySelectorAll(".modalcontent tr"));
            listItems.forEach((listItem) =>
            {
                ele.show(listItem);
            });
        }
    }
}
